export const ACTION_ITEMS_QUERY_KEY = 'actionItemsV2';

export type ActionItemScope = { kind: 'mine' } | { kind: 'everyone' } | { kind: 'user'; userId: string };

export const actionItemQueryKeys = {
	all: [ACTION_ITEMS_QUERY_KEY] as const,
	open: (assignedTo: string | undefined, search: string, accountId: string | undefined, contactId?: string | null) =>
		[ACTION_ITEMS_QUERY_KEY, 'open', assignedTo ?? 'everyone', search, accountId ?? null, contactId ?? null] as const,
	openPrefix: [ACTION_ITEMS_QUERY_KEY, 'open'] as const,
	completed: (
		assignedTo: string | undefined,
		search: string,
		accountId: string | undefined,
		contactId?: string | null
	) =>
		[
			ACTION_ITEMS_QUERY_KEY,
			'completed',
			assignedTo ?? 'everyone',
			search,
			accountId ?? null,
			contactId ?? null,
		] as const,
	completedPrefix: [ACTION_ITEMS_QUERY_KEY, 'completed'] as const,
	summary: (accountId: string | undefined, dayKey: string) =>
		[ACTION_ITEMS_QUERY_KEY, 'summary', accountId ?? null, dayKey] as const,
	summaryPrefix: [ACTION_ITEMS_QUERY_KEY, 'summary'] as const,
};
